<template>
  <div
    class="feature-announcement-card"
    data-testid="feature-announcement-card"
  >
    <div class="feature-announcement-card__header">
      <h2
        class="feature-announcement-card__name"
        data-testid="feature-announcement-card-name"
      >
        {{ name }}
      </h2>

      <AcvIconButton
        icon-type="close"
        aria-label="Dismiss announcement"
        class="feature-announcement-card__dismiss tw-shrink-0"
        data-testid="feature-announcement-card-dismiss"
        @click="emit('dismiss')"
      />
    </div>

    <img
      v-if="image"
      class="feature-announcement-card__image"
      :src="image"
      :alt="imageAlt"
      data-testid="feature-announcement-card-image"
    />

    <div
      class="feature-announcement-card__description"
      data-testid="feature-announcement-card-description"
    >
      <slot>{{ description }}</slot>
    </div>

    <AcvButton
      v-if="showCta"
      variant="link"
      icon-append="chevron_right"
      class="feature-announcement-card__cta"
      data-testid="feature-announcement-card-cta"
      @click="emit('cta')"
    >
      {{ ctaText }}
    </AcvButton>
  </div>
</template>

<script setup>
import { AcvButton, AcvIconButton } from '@acv/shared-vue';

defineProps({
  image: {
    type: String,
    default: '',
  },
  imageAlt: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  showCta: {
    type: Boolean,
    default: false,
  },
  ctaText: {
    type: String,
    default: 'Go to Walkthrough',
  },
});

const emit = defineEmits(['cta', 'dismiss']);
</script>

<style lang="scss" scoped>
.feature-announcement-card {
  @apply tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-md:tw-p-6;

  &__header {
    @apply tw-flex tw-items-start tw-justify-between tw-gap-2;
  }

  &__name {
    @apply tw-min-w-0 tw-flex-1 tw-break-words tw-text-lg tw-font-medium tw-md:tw-text-xl;
  }

  &__image {
    @apply tw-w-full tw-rounded-md tw-object-cover;
  }

  &__description {
    @apply tw-m-0 tw-text-sm tw-text-black-600 tw-md:tw-text-base;

    :deep(ul) {
      @apply tw-list-disc tw-pl-5;
    }

    :deep(ol) {
      @apply tw-list-decimal tw-pl-5;
    }
  }

  &__cta {
    @apply tw-self-start tw-text-secondary-base;
  }
}
</style>
